const permissionsPlugin = {

    install(Vue, options) {
        let permissionProvider = {
            initiated: false,
            permissions: [],
            populate(permissions) {
                this.permissions = permissions;
                this.initiated = true;
            },
            has(code) {
                if (this.permissions == undefined)
                    return false;
                return this.permissions.includes(code);
            },
            can(domain, permission) {
                return this.permissions.find(x => x.domain.toUpperCase() == domain.toUpperCase() && x.name.toUpperCase() == permission.toUpperCase()) != undefined;
            },
            domain(domain) {
                return this.permissions.some(x => x.domain.toUpperCase() == domain.toUpperCase());
            },
            module(module) {
                return this.permissions.some(x => x.module.toUpperCase() == module.toUpperCase());
            }
        };
        Vue.prototype.$pp = permissionProvider;
    }

}

export default permissionsPlugin;